import { Box, Container, Typography } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBg,
  SvgComponent,
  titleStyle,
} from "../../../Resources/Design/theme";
import { getSocials, shineAnimation } from "../../../Components/Navbar";

import logo from "../../../Resources/Design/logoa.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Motion } from "../../../Components/Motion";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const iconSize = "24px";

  return (
    <div>
      <footer>
        <Box sx={{ width: "100%", minHeight: "120px", bgcolor: colorApp }}>
          <Container
            maxWidth="lg"
            sx={{
              py: "24px",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component={Link}
              href={"/"}
              sx={{
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                justifyContent: "center",
                textDecoration: "none",
                p: "5px",
                pl: "0px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (location.pathname != "/") {
                  navigate("/");
                }

                setTimeout(() => {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                    block: "center",
                  });
                }, 0);
              }}
            >
              <Box
                component={"img"}
                src={logo}
                sx={{
                  height: "100px",
                  width: "100px",
                  userSelect: "none",
                  ...shineAnimation,
                }}
              />
            </Box>
            <Typography
              sx={{
                ...titleStyle,
                color: colorBg,
                textAlign: "left",
                ml: "24px",
                lineHeight: "32px",
                cursor: "default",
                userSelect: "none",
                display: { xs: "none", sm: "inline" },
              }}
            >
              S Čumákem
              <br />
              Na Stopě
            </Typography>
            <Box
              sx={{
                ml: "auto",
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                mt: "4px",
                height: "100%",
              }}
            >
              {getSocials({}, { color: colorBg }).map((data, i) => (
                <Motion key={`FootMot` + i}>
                  <Box sx={{ ml: "16px" }}>
                    <Box
                      component={"a"}
                      href={data.link}
                      target="_blank"
                      sx={{
                        height: iconSize,
                        maxHeight: iconSize,
                        cursor: "pointer",

                        ...data.sx,
                      }}
                    >
                      <SvgComponent
                        svg={data.icon}
                        style={{
                          width: iconSize,
                          height: iconSize,
                          color: colorBg,
                          ...data.sx,
                        }}
                        sx={{
                          maxHeight: iconSize,
                          ...data.sx,
                        }}
                      />
                    </Box>
                  </Box>
                </Motion>
              ))}
            </Box>
          </Container>
        </Box>
      </footer>
    </div>
  );
}
